import * as React from 'react'
import {compose} from 'redux'
import { Theme, createStyles, WithStyles, withStyles, Grid, Tabs, Tab } from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import { css } from 'src/conf/style'
import Page from 'src/shared/Page/Page'
import PageTitle from 'src/shared/PageTitle/PageTitle'
import Alert from 'src/shared/Alert/Alert'
import IndexTab from 'src/page/Consumer/MarketIndicators/IndexTab'
import autobind from 'autobind-decorator'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'

const styles = (t: Theme) => createStyles({
    tabsRoot: {
        marginBottom: t.spacing.unit * 2,
        borderBottom: '1px solid #e8e8e8'
    },
    tabsIndicator: {
        backgroundColor: t.palette.primary.main
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: t.typography.fontWeightRegular,
        marginRight: t.spacing.unit * 4,
        '&:hover': {
            color: t.palette.primary.main,
            opacity: 1,
        },
        '&$tabSelected': {
            color: t.palette.primary.main,
            fontWeight: t.typography.fontWeightMedium,
        },
        '&:focus': {
            color: t.palette.primary.main,
        },
    },
    tabSelected: {

    },
    tabLbl: {
        ...css.flexFullCenter
    },
    badge: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: t.palette.primary.main,
        marginLeft: '.75rem',
        minWidth: '20px'
    },
    badge2: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: 'rgb(63,81,181)',
        marginLeft: '.75rem',
        minWidth: '20px'
    }
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n {
}

class MarketIndicators extends React.Component<IProps, any>{

    state = {
        tabActive: "INDICES_ACTIONS",
    }

    @autobind
    private handleChange(event, value) {
        this.setState({ tabActive: value });
    };
    
    render() {
        const {t, classes} = this.props;
        const {tabActive} = this.state;
        return (
            <>
                <HelmetMeta title={t.App_title_page_MarketIndicators}/>
                <PageTitle title={t.market_indicators_page_title} icon="timeline" />
                
                <Page width="80%">
                    <Grid container>
                        <Grid item xs={12}>
                            <Alert type="warning">{t.market_indicators_page_warning}</Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <Tabs
                                value={tabActive}
                                onChange={this.handleChange}
                                scrollable scrollButtons="off"
                            >
                                <Tab
                                    disableRipple
                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                    label={t.market_indicators_tab_indices_actions_lbl}
                                    value="INDICES_ACTIONS"
                                />
                                <Tab
                                    disableRipple
                                    classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                    label={t.market_indicators_tab_change_spot_lbl}
                                    value="CHANGE_SPOT"
                                />
                            </Tabs>
                            {tabActive && <IndexTab type={tabActive} /> }
                        </Grid>
                    </Grid>
                </Page>
            </>
        )
    }
};

export default compose(
  withI18n,
  withStyles(styles)
)(MarketIndicators)



// WEBPACK FOOTER //
// ./src/page/Consumer/MarketIndicators/MarketIndicators.tsx